<!-- BaseToggleSwitch.vue (client) -->
<template tag="클라이언트 토글스위치 컴포넌트">
  <div class="toggle_switch">
    <label>
      <input type="checkbox" v-model="model" />
      <span>스위치</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { defineModel } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<boolean>({ default: false });
</script>
